import axios from 'axios';
// import store from '@/store/index';

axios.defaults.baseURL = 'http://192.168.207.210:8080/';
axios.defaults.headers.common.Authorization = 'Bearer ' + (localStorage.getItem('userToken') !== null ? localStorage.getItem('userToken') : 'null');
